import Vue from 'vue'
import Vuex from 'vuex'
import { getBaseInfo } from '../api/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    credits: 0,
    isLoggedIn: false,
    supabaseConfig: null,
    showAuthDialog: false,
    authMode: 'login',
    resetEmail: '',
    showInsufficientDialog: false
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      state.isLoggedIn = !!user
    },
    SET_CREDITS(state, credits) {
      state.credits = credits
    },
    SET_SUPABASE_CONFIG(state, config) {
      state.supabaseConfig = config
    },
    CLEAR_USER(state) {
      state.user = null
      state.isLoggedIn = false
      state.credits = 0
    },
    SET_AUTH_DIALOG(state, payload) {
      if (typeof payload === 'boolean') {
        state.showAuthDialog = payload
      } else {
        state.showAuthDialog = payload.show
        state.authMode = payload.mode || 'login'
        state.resetEmail = payload.email || ''
      }
    },
    SET_AUTH_MODE(state, mode) {
      state.authMode = mode
    },
    SET_INSUFFICIENT_DIALOG(state, show) {
      state.showInsufficientDialog = show
    }
  },
  actions: {
    async fetchCredits({ commit, dispatch }) {
      try {
        var body = await getBaseInfo()
        var d = (body && body.data) || {}
        var balance = d.balance !== undefined ? d.balance
          : (d.credits !== undefined ? d.credits : 0)
        commit('SET_CREDITS', balance || 0)
      } catch (e) {
        // getBaseInfo 报错（如 token 失效）→ 直接退出登录状态
        dispatch('logout')
      }
    },
    fetchUser() {
      // 已移除 — 登录状态从 localStorage 恢复
    },
    logout({ commit }) {
      localStorage.removeItem('sb-access-token')
      localStorage.removeItem('sb-user')
      commit('CLEAR_USER')
    }
  }
})
